(function() {
    class TeaserTiles {
        constructor() {
            this.managerData = {};
            this.activityData = {};
            this.lastsearchData = {};
            this.tilesContainer = document.querySelector('.c24Tiles');
            this.tilesContainerWrapper = document.querySelector('.c24TilesWrapper');
            this.loadingTiles = this.tilesContainer.querySelectorAll('.c24-loading-tile');
            this.tileIndex = 0;
            this.filterType = 'showAll'; // 'showAll'
            this.defaultTilesOrder = this.getDefaultTilesOrder();
            this.tilesOrder = [...this.defaultTilesOrder];
            this.filterChipLabelMap = this.getFilterChipLabelMap();
            this.trackingOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            };
            this.staticSliderNavButtonsTracked = {
                left: false,
                right: false,
            };
            this.staticSliderNavButtonsObserver = new IntersectionObserver(this.staticSliderNavButtonsCallback.bind(this), this.trackingOptions);

            this.mutationObserver = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const target = mutation.target;
                        const isHidden = target.classList.contains('c24Hidden');
                        const isNextButton = target.classList.contains('navNext');
                        const isPrevButton = target.classList.contains('navPrev');
                        if (isHidden) {
                            this.staticSliderNavButtonsObserver.unobserve(target);
                            if (isNextButton) {
                                this.staticSliderNavButtonsTracked.right = false;
                            }
                            if (isPrevButton) {
                                this.staticSliderNavButtonsTracked.left = false;
                            }
                        } else {
                            this.staticSliderNavButtonsObserver.observe(target);
                        }
                    }
                });
            });

            this.sliderConfig = {
                sliding: false,
                scrollDebounceMs: 200,
                scrollTolerance: 5,
            };

            this.initTracking();

            const lastSearchTileTemplate = this.tilesContainer.querySelector('.c24TileTemplate.c24-home-last-searches-tile');
            const activityTileTemplate = this.tilesContainer.querySelector('.c24TileTemplate.c24-home-activity-tile');
            const managerTileTemplate = this.tilesContainer.querySelector('.c24TileTemplate.c24-home-activity-tile.c24-home-manager-tile');
            const loginTileTemplate = this.tilesContainer.querySelector('.c24TileTemplate.c24TileLogin');
            const vcTileTemplate = this.tilesContainer.querySelector('.c24TileTemplate.c24TileVersicherungscenter');

            this.templates = {
                lastSearchTileTemplate,
                activityTileTemplate,
                managerTileTemplate,
                loginTileTemplate,
                vcTileTemplate,
            };

            this.loadTileData();
        }
        getDefaultTilesOrder() {
            return [
                {
                    type: 'submit',
                    handler: 'renderSubmitDataTile',
                },
                {
                    type: 'activity',
                    handler: 'renderActivityTile',
                },
                {
                    type: 'lastSearches',
                    handler: 'renderLastSearchTile',
                },
                {
                    type: 'manager',
                    subtype: 'promo',
                    handler: 'renderManagerTile',
                    filter: item => item.type === 'promo',
                },
                {
                    type: 'manager',
                    handler: 'renderManagerTile',
                },
            ];
        }
        getFilterChipLabelMap() {
            return {
                todos: {
                    types: ['submit', 'activity'],
                    singular: 'offene Aufgabe',
                    plural: 'offene Aufgaben',
                    trackingPrefix: 'oa',
                },
                lastSearches: {
                    types: ['lastSearches'],
                    singular: 'Vergleich',
                    plural: 'Vergleiche',
                    trackingPrefix: 'ls',
                },
                promos: {
                    types: ['manager'],
                    subtypes: ['promo'],
                    singular: 'Angebote & Aktionen',
                    plural: 'Angebote & Aktionen',
                    trackingPrefix: 'promo',
                },
                showAll: 'alles anzeigen',
            };
        }
        loadTileData() {
            const activityDataPromise = this.getTiles(
                this.activityData,
                'api/?k=24&a=getactivitytiles'
                + '&deviceoutput=' + window.c24LpDeviceOutput
                + '&timeout=' + this.getTimeout(),
            );

            const lastsearchDataPromise = this.getTiles(
                this.lastsearchData,
                'api/?k=24&a=getlastsearchtiles'
                + '&deviceoutput=' + window.c24LpDeviceOutput
                + '&timeout=' + this.getTimeout(),
            );

            Promise.allSettled([activityDataPromise, lastsearchDataPromise]).finally(() => {
                const urlParams = new URLSearchParams(window.location.search);
                const urlPreferTile = urlParams.get('tile');
                const hash = urlParams.get('tile_preview_hash');
                const lastSearchPpsetIds = this.getLastsearchPpsetIds();

                const managerDataPromise = this.getTiles(
                    this.managerData,
                    'api/?k=24&a=getmanagertiles'
                        + (urlPreferTile ? '&prefer=' + urlPreferTile : '')
                        + '&deviceoutput=' + window.c24LpDeviceOutput
                        + '&timeout=' + this.getTimeout()
                        + (lastSearchPpsetIds.length > 0 ? '&lastSearchPpsetIds=' + lastSearchPpsetIds : '')
                        + (hash ? '&hash=' + hash : ''),
                );

                managerDataPromise.then(() => {
                    this.renderTiles();
                    const loadTilesEvent = new CustomEvent('loadTilesEvent', {});
                    document.dispatchEvent(loadTilesEvent);
                    if (this.lastsearchData?.status === 408) {
                        this.secondLoad();
                    }
                }).catch((error) => {
                    console.error('Failed load manager tiles: ' + error);
                });
            });
        }
        initTracking() {
            const filterChipLabelMap = this.filterChipLabelMap;
            const mutationObserver = this.mutationObserver;
            const staticSliderNavButtonsObserver = this.staticSliderNavButtonsObserver;
            const options = this.trackingOptions;
            const self = this;
            document.addEventListener('loadTilesEvent', function() {
                setTimeout(function() {
                    self.setupTileObserverTracking(options);

                    const filterContainer = document.querySelector('#c24FilterContainer');
                    const hasNoFilterChips = filterContainer.classList.contains('c24Hidden');

                    if (hasNoFilterChips) {
                        const sliderContainer = document.querySelector('.c24TilesWrapper');
                        let filterChipTracked = false;
                        const filterChipCallback = (entries) => {
                            entries.forEach(() => {
                                if (!filterChipTracked) {
                                    window._paq.push([
                                        'trackEvent',
                                        window.c24Lp.getMatomoEventCategory(),
                                        'filter-chip:show',
                                        'filter-chip:0:notshow',
                                    ]);
                                    filterChipTracked = true;
                                }
                            });
                        };
                        const filterChipObserver = new IntersectionObserver(filterChipCallback, options);
                        filterChipObserver.observe(sliderContainer);
                    } else {
                        const filterChips = document.querySelectorAll('.c24FilterButton');
                        for (let i = 0; i < filterChips.length; i++) {
                            const filterChip = filterChips[i];
                            const filterMapKey = filterChip.dataset.filter;
                            const filterChipPrefix = filterMapKey === 'none' ? 'displayall' : filterChipLabelMap[filterMapKey].trackingPrefix;
                            const filterTrackingLabel = filterChipPrefix + '-filter';
                            filterChip.addEventListener('click', function() {
                                window._paq.push([
                                    'trackEvent',
                                    window.c24Lp.getMatomoEventCategory(),
                                    'filter-chip:click',
                                    'filter-chip:' + (i + 1) + ':' + filterTrackingLabel,
                                ]);
                            });
                            let filterChipTracked = false;
                            const filterChipCallback = (entries) => {
                                entries.forEach((entry) => {
                                    if (entry.isIntersecting && !filterChipTracked) {
                                        window._paq.push([
                                            'trackEvent',
                                            window.c24Lp.getMatomoEventCategory(),
                                            'filter-chip:show',
                                            'filter-chip:' + (i + 1) + ':' + filterTrackingLabel,
                                        ]);
                                        filterChipTracked = true;
                                    }
                                });
                            };
                            const filterChipObserver = new IntersectionObserver(filterChipCallback, options);
                            filterChipObserver.observe(filterChip);
                        }
                    }

                    const staticSliderNavButtons = document.querySelectorAll('.c24StaticSliderNav');
                    if (staticSliderNavButtons.length) {
                        staticSliderNavButtons.forEach((button) => {
                            mutationObserver.observe(button, {
                                attributes: true,
                                attributeFilter: ['class'],
                            });
                            if (!button.classList.contains('c24Hidden')) {
                                staticSliderNavButtonsObserver.observe(button);
                            }
                        });
                    }
                }, 1);
            });
        }
        setupTileObserverTracking(options) {
            const dataAttributes = [
                'prefix',
                'position',
                'product',
                'type',
            ];
            const tileCallback = window.c24Lp.createTileCallback('tile:show', dataAttributes);
            window.c24Lp.setupTileObserver(tileCallback, '.c24Tile:not(.c24Hidden)', options);
        }
        setupTileClickTracking() {
            const dataAttributes = [
                'prefix',
                'position',
                'product',
                'type',
            ];
            window.c24Lp.createClickTracking('.c24Tile', dataAttributes, 'tile');
        }
        staticSliderNavButtonsCallback(entries) {
            entries.forEach((entry) => {
                const action = entry.target.classList.contains('navPrev') ? 'left' : 'right';
                if (entry.isIntersecting && !this.staticSliderNavButtonsTracked[action]) {
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'tile-carousel:show',
                        `tile-carousel:::${action}`,
                    ]);
                    this.staticSliderNavButtonsTracked[action] = true;
                }
            });
        }
        getTiles(data, query) {
            const timeoutMs = this.getTimeout() * 1000 * 2;
            return $.ajax({
                type: 'GET',
                url: window.c24LpRoot + query,
                dataType: 'json',
                timeout: timeoutMs,
                async: true,
            }).done(function(json) {
                Object.assign(data, json);
            }).catch((error) => {

                window.c24Lp.logError('Failed to retrieve desktop tiles', {
                    url: window.c24LpRoot + query,
                    error: {
                        status: error.status,
                        statusText: error.statusText,
                        responseText: error.responseText,
                        message: error.message,
                    },
                    trace: error.trace,
                    deviceOutput: window.c24LpDeviceOutput,
                    timeoutMs: timeoutMs,
                });
            });
        }
        getLastsearchPpsetIds() {
            const lastsearchPpsetIds = [];
            for (const lastSearchesItem of this.lastsearchData?.lastSearchTiles ?? []) {
                lastsearchPpsetIds.push(lastSearchesItem.productKey);
            }
            return lastsearchPpsetIds;
        }
        getTimeout() {
            if (!window.c24LpIsProduction) {
                return 5;
            }
            return 3;
        }
        secondLoad() {
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tile:secondLoad',
            ]);
        }
        lazyLoadTooltipText(apiUrl, setTextCallback) {
            let xhr = new XMLHttpRequest();
            xhr.onload = function () {
                if (xhr.readyState !== 4) {
                    return;
                }
                let data = JSON.parse(xhr.responseText);
                if (xhr.status !== 200 || !data.data?.label) {
                    return;
                }

                setTextCallback(data.data.label);
            };

            xhr.open('GET', apiUrl, true);
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhr.send();
        }
        renderActivityTile(activityItem, activityTile, tileIndex) {
            this.setTileContent(activityItem, activityTile, 'ws', tileIndex);
        }
        renderSubmitDataTile(submitDataItem, submitDataTile, tileIndex) {
            this.setTileContent(submitDataItem, submitDataTile, 'dn', tileIndex);
        }
        setTileContent(item, tile, type, tileIndex) {
            const tileLinkWrapper = tile.querySelector('.c24-home-tile__primary-action');
            const tileHeadline = tile.querySelector('.c24-home-activity-tile__headline');
            const tileImg = tile.querySelector('.c24-home-activity-tile__img');
            const tileDetailLine1 = tile.querySelector('.detailLine1');
            const tileDetailLine2 = tile.querySelector('.detailLine2');
            const tileDetailLine3 = tile.querySelector('.detailLine3');
            const tileDetailsContainer = tile.querySelector('.detailsContainer');
            const tileTooltipContainer = tile.querySelector('.tooltipContainer');
            const tileTooltipText = tile.querySelector('.tooltipText');
            const tileTariffPeriod = tile.querySelector('.c24-home-activity-tile__price-prefix');
            const tileTariffPrice = tile.querySelector('.c24-home-activity-tile__price');
            const tileStatus = tile.querySelector('.c24-home-activity-tile__status');
            const tileStatusContainer = tile.querySelector('.statusContainer');
            const tileCta = tile.querySelector('.cta');

            const itemProductKey = item.productKey;
            const itemHeadline = item.headline;
            const itemTileUrl = (type === 'dn') ? item.ctaUrl : item.tileUrl;
            const itemImage = item.imageUrl;
            const itemDetailLine1 = item.detailLine1;
            const itemDetailLine2 = item.detailLine2;
            const itemDetailLine3 = item.detailLine3;
            const itemActivityStatusText = item.activityStatusText;
            const itemActivityStatus = item.activityStatus;
            const itemTooltipText = item.tooltipText;
            const itemTariffPeriod = item.tariff?.period;
            const itemTariffPrice = item.tariff?.price;
            const itemCtaText = item.ctaText;
            const itemCtaUrl = item.ctaUrl;
            const itemCase = item.case;

            tileLinkWrapper.href = itemTileUrl ?? '';
            tileHeadline.innerHTML = itemHeadline;

            if (itemImage) {
                tileImg.style.backgroundImage = `url("${itemImage}")`;
            } else {
                tileImg.style.backgroundImage = 'none';
            }

            if (itemProductKey === 'vermop') {
                if (itemCase === 'renewal') {
                    tileDetailLine1.innerText = window.c24.lp.activities.mpdv.getCoverageLabel(itemDetailLine1);
                    tileDetailLine2.innerText = window.c24.lp.activities.mpdv.getVehicleLabel(itemDetailLine2);
                    tileDetailLine3.innerText = itemDetailLine3;
                } else {
                    tileDetailLine1.innerText = itemDetailLine1;
                    tileDetailLine2.remove();
                    tileDetailLine3.remove();
                }
            } else if (itemProductKey === 'veresc') {
                if (itemCase === 'renewal') {
                    tileDetailLine1.innerText = window.c24.lp.activities.mpdv.getCoverageLabel(itemDetailLine1);
                    tileDetailLine2.innerText = itemDetailLine2;
                    tileDetailLine3.remove();
                } else {
                    tileDetailLine1.innerText = itemDetailLine1;
                    tileDetailLine2.remove();
                    tileDetailLine3.remove();
                }
            } else {
                if (itemDetailLine1) {
                    tileDetailLine1.innerText = itemDetailLine1;
                } else {
                    tileDetailLine1.remove();
                }

                if (itemDetailLine2) {
                    tileDetailLine2.innerText = itemDetailLine2;
                } else {
                    tileDetailLine2.remove();
                }

                if (itemDetailLine3) {
                    tileDetailLine3.innerText = itemDetailLine3;
                } else {
                    tileDetailLine3.remove();
                }
            }

            if (tileDetailsContainer.children.length === 0) {
                tileDetailsContainer.remove();
            }

            if (itemActivityStatus && itemActivityStatusText) {
                tileStatus.classList.add('c24-home-activity-tile__status--' + itemActivityStatus);
                tileStatus.innerText = itemActivityStatusText;
            } else {
                tileStatus?.remove();
                tileStatusContainer?.remove();
            }

            if (itemTariffPeriod && itemTariffPrice) {
                tileTariffPeriod.innerHTML = itemTariffPeriod;
                tileTariffPrice.innerHTML = itemTariffPrice;
            } else {
                tileTariffPrice.innerHTML = '\u00A0';
            }

            if (itemTooltipText) {
                tileTooltipText.innerHTML = itemTooltipText;
            } else {
                tileTooltipText.remove();
                tileTooltipContainer.remove();
            }

            if (itemCtaText && itemCtaUrl) {
                tileCta.href = itemCtaUrl;
                tileCta.innerHTML = itemCtaText;
            } else {
                tileCta?.remove();
            }

            tile.classList.add('c24-home-contract-tile');
            tile.classList.add(type);
            tile.classList.add(itemProductKey);

            tile.setAttribute('data-prefix', 'tile');
            tile.setAttribute('data-type', type);
            tile.setAttribute('data-product', itemProductKey);
            tile.setAttribute('data-position', tileIndex + 1);

            tile.classList.remove('c24Hidden');
        }
        renderLastSearchTile(lastSearchesItem, lastSearchesTile, tileIndex) {
            const tileLinkWrapper = lastSearchesTile.querySelector('.c24-home-tile__primary-action');
            const headlineEle = lastSearchesTile.querySelector('.c24-home-activity-tile__headline');
            const imgEle = lastSearchesTile.querySelector('.c24-home-activity-tile__img');
            const titleEle = lastSearchesTile.querySelector('.c24-home-activity-tile__title');
            const subTitleEle = lastSearchesTile.querySelector('.c24-home-activity-tile__subtitle');
            const dateEle = lastSearchesTile.querySelector('.c24-home-activity-tile__date');
            const linkEle = lastSearchesTile.querySelector('.c24-home-activity-tile__link');
            const hintDiv = lastSearchesTile.querySelector('.c24-home-activity-tile__hint');

            tileLinkWrapper.href = lastSearchesItem.item_link;
            headlineEle.innerHTML = lastSearchesItem.title;
            imgEle.style.backgroundImage = 'url("' + lastSearchesItem.img + '")';
            titleEle.innerText = lastSearchesItem.partial1;
            dateEle.innerText = lastSearchesItem.partial2 !== '' ? lastSearchesItem.partial2 : '\u00A0';
            linkEle.href = lastSearchesItem.item_link;
            linkEle.innerHTML = lastSearchesItem.item_link_text;

            lastSearchesTile.setAttribute('data-prefix', 'tile');
            lastSearchesTile.setAttribute('data-type', 'ls');
            lastSearchesTile.setAttribute('data-product', lastSearchesItem.productKey);
            lastSearchesTile.setAttribute('data-position', tileIndex + 1);

            if (lastSearchesItem.price !== '') {
                const pricePrefixEle = subTitleEle.querySelector('.c24-home-last-searches-tile__price-prefix');
                const priceEle = subTitleEle.querySelector('.c24-home-last-searches-tile__price');
                const priceSuffixEle = subTitleEle.querySelector('.c24-home-last-searches-tile__price-suffix');

                pricePrefixEle.innerHTML = lastSearchesItem.price_prefix + ' ';
                priceEle.innerHTML = lastSearchesItem.price;
                priceSuffixEle.innerHTML = ' ' + lastSearchesItem.price_suffix;
            } else {
                const priceEle = lastSearchesTile.querySelector('.c24-home-last-searches-tile__price');
                priceEle.innerHTML = '\u00A0';
            }

            hintDiv?.remove();

            lastSearchesTile.classList.add('c24-home-last-searches-tile');
            lastSearchesTile.classList.remove('c24-home-contract-tile');
            dateEle.classList.remove('c24Hidden');
            lastSearchesTile.classList.remove('c24Hidden');
        }
        renderManagerTile(managerItem, managerTile, tileIndex, fullApiUrl) {
            if (!managerItem) {
                return;
            }

            const headlineEle = managerTile.querySelector('.c24TileHeadline');
            const tileLink = managerTile.querySelector('.c24TilePrimaryAction');
            const imgEle = managerTile.querySelector('.c24TileImage');
            const overlayTextEle = managerTile.querySelector('.c24TileOverlayText');

            managerTile.classList.add(managerItem.classname);
            managerTile.classList.add(managerItem.type);

            managerTile.setAttribute('data-prefix', 'tile');
            managerTile.setAttribute('data-type', managerItem.type);
            managerTile.setAttribute('data-product', managerItem.uniqueId);
            managerTile.setAttribute('data-position', tileIndex + 1);

            tileLink.href = managerItem.link ?? '';

            if (managerItem?.flow_active && managerItem?.flow_name && managerItem?.flow_entry) {
                window.c24LpAddChatbotElement({
                    chatFlowName: managerItem.flow_name,
                    chatFlowEntry: managerItem.flow_entry,
                }, tileLink);

                tileLink.onclick = function(e) {
                    e.preventDefault();
                };
            }

            headlineEle.innerHTML = managerItem.headline ?? '';
            imgEle.style.backgroundImage = 'url("' + fullApiUrl + '")';

            if (managerItem.type === 'promo' && managerItem.image_overlay_text) {
                overlayTextEle.classList.remove('c24Hidden');
                overlayTextEle.innerHTML = managerItem.image_overlay_text;
            } else {
                overlayTextEle.classList.add('c24Hidden');
            }

            if (managerItem.css) {
                const styleSheet = document.createElement('style');
                const scopeClass = managerItem.type + managerItem.ppset_id.charAt(0).toUpperCase() + managerItem.ppset_id.slice(1);
                styleSheet.innerText = this.scopeCSS(managerItem.css, scopeClass);

                managerTile.appendChild(styleSheet);
            }

            managerTile.classList.remove('c24Hidden');
        }
        renderLoginTile(loginItem, loginTile, tileIndex) {
            const headlineEle = loginTile.querySelector('.c24TileHeadline');
            const buttonEle = loginTile.querySelector('.c24TileButton');
            const subheaderEle = loginTile.querySelector('.c24TileSubheader');
            const imageEle = loginTile.querySelector('.c24TileImageLogin');

            headlineEle.innerHTML = loginItem.headline;
            buttonEle.href = loginItem.link;
            buttonEle.innerHTML = loginItem.button;
            subheaderEle.innerHTML = loginItem.subheader;
            imageEle.src = loginItem.file;

            loginTile.setAttribute('data-prefix', 'tile');
            loginTile.setAttribute('data-type', 'default');
            loginTile.setAttribute('data-product', 'login');
            loginTile.setAttribute('data-position', tileIndex + 1);

            loginTile.classList.remove('c24Hidden');
        }
        renderVcTile(vcItem, vcTile, tileIndex) {
            const headlineEle = vcTile.querySelector('.c24TileHeadline');
            const buttonEle = vcTile.querySelector('.c24TileButton');
            const subheader1Ele = vcTile.querySelector('.c24TileSubheader1');
            const subheader2Ele = vcTile.querySelector('.c24TileSubheader2');

            headlineEle.innerHTML = vcItem.headline;
            buttonEle.href = vcItem.link;
            buttonEle.innerHTML = vcItem.button;
            subheader1Ele.innerHTML = vcItem.subheader1;
            subheader2Ele.innerHTML = vcItem.subheader2;

            vcTile.setAttribute('data-prefix', 'tile');
            vcTile.setAttribute('data-type', 'default');
            vcTile.setAttribute('data-product', 'vc-jumpin');
            vcTile.setAttribute('data-position', tileIndex + 1);

            vcTile.classList.remove('c24Hidden');
        }
        hideLoadingTile(tileIndex) {
            if (this.loadingTiles[tileIndex]) {
                this.loadingTiles[tileIndex].classList.add('c24Hidden');
            }
        }
        resetAllTiles() {
            const managerTiles = this.tilesContainer.querySelectorAll('.c24-home-manager-tile:not(.c24TileTemplate)');
            const lastSearchesTiles = this.tilesContainer.querySelectorAll('.c24-home-last-searches-tile:not(.c24TileTemplate)');
            const activityTiles = this.tilesContainer.querySelectorAll('.c24-home-contract-tile:not(.c24TileTemplate)');
            const loginTiles = this.tilesContainer.querySelectorAll('.c24TileLogin:not(.c24TileTemplate)');
            const vcTiles = this.tilesContainer.querySelectorAll('.c24TileVersicherungscenter:not(.c24TileTemplate)');

            for (const tile of [
                ...managerTiles,
                ...lastSearchesTiles,
                ...activityTiles,
                ...loginTiles,
                ...vcTiles,
            ]) {
                tile?.remove();
            }
        }
        scopeCSS(css, scope) {
            return css.replace(/(^|\})\s*([^{}]+)/g, (match, closeBrace, selectors) => {
                return closeBrace + ' .' + scope + ' ' + selectors;
            });
        }
        cloneAndAppendTemplate(template, tileIndex) {
            const clonedTemplate = template.cloneNode(true);
            clonedTemplate.classList.remove('c24TileTemplate');
            clonedTemplate.classList.add('c24Tile' + (tileIndex + 1));
            const referenceNode = this.tilesContainer.children[tileIndex] || null;
            this.tilesContainer.insertBefore(clonedTemplate, referenceNode);
            return clonedTemplate;
        }
        getParsedPrice(value, suffix) {
            const regex = /^\d*\.\d{2}$/;
            const newValue = value?.toLocaleString('de-DE');

            if (!regex.test(value) && newValue.includes(',')) {
                return `${newValue}0 ` + suffix;
            }

            if (!newValue.includes(',')) {
                return `${newValue},00 ` + suffix;
            }

            return newValue + ' ' + suffix;
        }
        getPriceFromCents(value) {
            return (value / 100)?.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
            });
        }
        renderTiles() {
            this.resetAllTiles();
            this.resetTilesSliderEvents();
            let apiUrl = this.managerData.apiUrl;

            this.tileIndex = 0;
            const tilesTypesMap = new Map();

            if (this.managerData?.previewTile) {
                this.handlePreviewTile(this.managerData.previewTile, apiUrl);
                this.tileIndex++;
            }

            for (const tileConfig of this.tilesOrder) {
                const {
                    type, subtype, handler, filter,
                } = tileConfig;
                const tileData = this.getTileData(type, subtype);

                if (this.isEmptyObject(tileData)) {
                    continue;
                }

                this.tileIndex = this.processTileData(tileData, type, handler, apiUrl, filter, this.tileIndex);
                const dataLength = tileData.length;
                if (dataLength > 0) {
                    const tilesTypesMapKey = subtype === 'promo' ? subtype : type;
                    tilesTypesMap.set(tilesTypesMapKey, dataLength);
                }
            }

            this.renderFilterChips(tilesTypesMap);

            let loadingTileIndex = 0;

            while (loadingTileIndex < 3) {
                this.hideLoadingTile(loadingTileIndex);
                loadingTileIndex++;
            }

            if (window.c24IsLoggedIn) {
                this.handleVCTile();
            } else {
                this.handleLoginTile();
            }
            this.hideLoadingTile(loadingTileIndex);

            this.tileIndex++;

            if (this.tileIndex >= 3) {
                this.tilesContainerWrapper.classList.add('withStaticSlider');
                this.registerTilesSliderEvents();
            }

            this.registerTilesFilterEvents();

            this.setupTileClickTracking();
        }
        processTileData(tileData, type, handler, apiUrl, filter, tileIndex) {
            for (const tilesItem of tileData) {
                if (filter && !filter(tilesItem)) {
                    continue;
                }
                tileIndex = this.processTile(tilesItem, type, handler, apiUrl, tileIndex);
                this.hideLoadingTile(tileIndex);
            }
            return tileIndex;
        }
        processTile(item, type, handler, apiUrl, tileIndex) {
            const template = this.getTemplate(type);
            const tile = this.cloneAndAppendTemplate(template, tileIndex);
            if (type === 'manager') {
                const fullApiUrl = apiUrl + '/get/tile/asset/?deviceOutput=desktop&productId=' + item.uniqueId + '&tileId=' + item.tile_id;
                this[handler](item, tile, tileIndex, fullApiUrl);
            } else {
                this[handler](item, tile, tileIndex);
            }
            return tileIndex + 1;
        }
        getTileData(type, subtype = null) {
            switch (type) {
                case 'submit':
                    return this.activityData?.submitDataTiles;
                case 'lastSearches':
                    if (this.lastsearchData?.lastSearchTiles?.length > 0) {
                        return this.lastsearchData?.lastSearchTiles;
                    }
                    return [];
                case 'activity':
                    return this.activityData?.activityTiles;
                case 'manager':
                    if (this.managerData?.managerTiles?.length > 0) {
                        return subtype === 'promo'
                            ? this.managerData.managerTiles.filter(item => item.type === 'promo')
                            : this.managerData.managerTiles.filter(item => item.type !== 'promo');
                    }
                    return [];
                default:
                    return null;
            }
        }
        getTemplate(type) {
            if (type === 'manager') return this.templates.managerTileTemplate;
            if (type === 'lastSearches') return this.templates.lastSearchTileTemplate;
            return this.templates.activityTileTemplate;
        }
        determineLoginTilePositionInSlider() {
            if (this.filterType !== 'showAll') {
                return this.tileIndex;
            }
            const styles = window.getComputedStyle(this.tilesContainerWrapper);
            const tilesMarginX = styles.getPropertyValue('--tilesMarginX') || '10px';
            const tilesWidth = styles.getPropertyValue('--tilesWidth') || '298px';
            const tilesGap = styles.getPropertyValue('--tilesGap') || '20px';
            const viewportWidth = window.innerWidth;

            const itemWidth = parseInt(tilesMarginX, 10) * 2 + parseInt(tilesWidth, 10) + parseInt(tilesGap, 10);
            let resultPosition = 4 * itemWidth < viewportWidth && viewportWidth > 1350 ? 3 : 2;
            return Math.min(this.tileIndex, Math.min(resultPosition, 3));
        }
        updateDataSetPosition(position) {
            const tilesContainerChildren = this.tilesContainer.querySelectorAll(':scope > :not(.c24Hidden)');
            for (let i = position - 1; i < tilesContainerChildren.length; i++) {
                const tile = tilesContainerChildren[i];
                if (tile && tile.dataset && tile.dataset.position) {
                    tile.dataset.position = i + 1;
                }
            }
        }
        handleLoginTile() {

            if (this.isEmptyObject(this.managerData?.loginTile)) {
                return;
            }

            const position = this.determineLoginTilePositionInSlider(this.tileIndex);
            const loginTile = this.cloneAndAppendTemplate(this.templates.loginTileTemplate, position);
            this.renderLoginTile(this.managerData.loginTile, loginTile, position);
            this.updateDataSetPosition(position);
        }
        rerenderLoginTileInSlider() {
            if (this.tilesContainerWrapper.classList.contains('withStaticSlider')) {
                const loginTile = this.tilesContainer.querySelector('.c24TileLogin');
                if (!loginTile) return;
                const loginTileClone = loginTile.cloneNode(true);
                loginTile?.remove();
                const position = this.determineLoginTilePositionInSlider();
                this.tilesContainer.insertBefore(loginTileClone, this.tilesContainer.children[position]);
                this.updateDataSetPosition(position);
            }
        }
        handleVCTile() {

            if (this.isEmptyObject(this.managerData?.vcTile)) {
                return;
            }

            const vcTile = this.cloneAndAppendTemplate(this.templates.vcTileTemplate, this.tileIndex);
            this.renderVcTile(this.managerData.vcTile, vcTile, this.tileIndex);
        }
        updateFilterChipState() {
            const filterButtons = document.querySelectorAll('.c24FilterButton');
            for (const button of filterButtons) {
                const buttonFilter = button.dataset.filter === 'none' ? 'showAll' : button.dataset.filter;
                button.classList.toggle('active', buttonFilter === this.filterType);
            }
        }
        renderFilterChips(tilesTypesMap) {
            const filterChipsContainer = document.querySelector('.c24FilterContainer');
            if (!this.shouldRenderFilterChips(filterChipsContainer, tilesTypesMap)) {
                return;
            }
            const clonedFilterChipTemplate = filterChipsContainer.querySelector('.c24FilterBox');
            clonedFilterChipTemplate.classList.remove('c24Hidden');
            filterChipsContainer.innerHTML = '';
            const filterChipEntries = Object.entries(this.filterChipLabelMap);
            for (const [key, value] of filterChipEntries) {
                const chipLabel = this.getChipLabel(key, value, tilesTypesMap);
                if (!chipLabel) {
                    continue;
                }
                const filterChip = this.createFilterChip(clonedFilterChipTemplate, key, chipLabel);

                filterChipsContainer.appendChild(filterChip);
            }

            filterChipsContainer.classList.remove('c24Hidden');
        }
        shouldRenderFilterChips(filterChipsContainer, tilesTypesMap) {
            return filterChipsContainer.classList.contains('c24Hidden') &&
                !(tilesTypesMap.size <= 1 || (tilesTypesMap.size === 2 && tilesTypesMap.has('promo') && tilesTypesMap.has('manager')));
        }
        getChipLabel(key, value, tilesTypesMap) {
            if (key === 'showAll') return value;

            let tilesLength = 0;
            const targets = value.subtypes || value.types || [];
            for (const target of targets) {
                if (tilesTypesMap.get(target)) {
                    tilesLength += tilesTypesMap.get(target);
                }
            }

            if (tilesLength > 0) {
                return tilesLength > 1 ? value.plural : value.singular;
            }

            return null;
        }
        createFilterChip(template, key, chipLabel) {
            const filterChip = template.cloneNode(true);
            filterChip.classList.add(key + 'Chip');
            const filterButton = filterChip.querySelector('.c24FilterButton');
            filterButton.innerText = chipLabel;
            filterButton.dataset.filter = key === 'showAll' ? 'none' : key;

            if (key === this.filterType) {
                filterButton.classList.add('active');
            }

            return filterChip;
        }
        filterTiles() {
            if (this.filterType === 'showAll') {
                this.tilesOrder = this.defaultTilesOrder;
            } else {
                const filterKey = this.filterChipLabelMap[this.filterType];
                const {
                    types, subtypes,
                } = filterKey;
                this.tilesOrder = this.defaultTilesOrder.filter(tileConfig => {
                    const {
                        type, subtype,
                    } = tileConfig;

                    if (types.includes(type)) {
                        if (subtypes) {
                            return subtypes.includes(subtype);
                        }
                        return true;
                    }
                });
            }
        }
        registerTilesFilterEvents() {
            const filterButtons = document.querySelectorAll('.c24FilterButton');
            for (const button of filterButtons) {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    const clickedButton = event.currentTarget;
                    let clickedFilterType = clickedButton.dataset.filter;
                    if (clickedFilterType === 'none') {
                        clickedFilterType = 'showAll';
                    }
                    if (clickedButton.classList.contains('active')) {
                        return false;
                    }

                    this.filterType = clickedFilterType;

                    this.filterTiles();
                    this.updateFilterChipState();
                    this.renderTiles();
                });
            }
        }
        resetTilesSliderEvents() {
            const navPrev = document.querySelector('.c24StaticSliderNav.navPrev');
            const navNext = document.querySelector('.c24StaticSliderNav.navNext');
            const navDotsContainer = document.querySelector('.c24StaticSliderNavDots');
            const scrollContainer = this.tilesContainer;
            this.sliderConfig.sliding = false;

            navPrev.classList.add('c24Hidden');
            navNext.classList.add('c24Hidden');
            navDotsContainer.innerHTML = '';
            navDotsContainer.classList.add('c24Hidden');

            this.tilesContainerWrapper.classList.remove('withStaticSlider');
            scrollContainer.scrollTo({
                left: 0,
                behavior: 'auto',
            });
            scrollContainer.removeEventListener('scroll', this.checkSliderArrowsVisibility);
            window.removeEventListener('resize', this.checkSliderArrowsVisibility);
        }
        registerTilesSliderEvents() {
            const tiles = this.tilesContainer.querySelectorAll('.c24Tile:not(.c24Hidden)');
            const totalTilesCount = tiles.length;
            this.sliderConfig.sliding = false;

            const scrollContainer = this.tilesContainer;
            const navPrev = document.querySelector('.c24StaticSliderNav.navPrev');
            const navNext = document.querySelector('.c24StaticSliderNav.navNext');
            const navDotsContainer = document.querySelector('.c24StaticSliderNavDots');

            let tileWidth;
            let visibleTilesCount;
            let resizeListener;
            let scrollListener;
            let navPrevListener;
            let navNextListener;

            const recalculateItemWidth = () => {
                const styles = window.getComputedStyle(this.tilesContainerWrapper);
                tileWidth =
                    parseInt(styles.getPropertyValue('--tilesMarginX'), 10) * 2 +
                    parseInt(styles.getPropertyValue('--tilesWidth'), 10) +
                    parseInt(styles.getPropertyValue('--tilesGap'), 10);

                visibleTilesCount = Math.floor(scrollContainer.clientWidth / tileWidth);

                updateNavigationDots();
            };
            const updateNavigationAndSliderConfig = (currentScrollLeft) => {
                const currentTilesCount = this.tilesContainer.querySelectorAll('.c24Tile:not(.c24Hidden)').length;
                this.sliderConfig.sliding = false;
                updateActiveNavDot(currentScrollLeft, currentTilesCount);
                this.checkSliderArrowsVisibility();
            };
            const scrollElement = (direction) => {
                if (this.sliderConfig.sliding) {
                    return;
                }
                this.sliderConfig.sliding = true;
                if (tileWidth === undefined || tileWidth === 0) {
                    recalculateItemWidth();
                }
                let targetScrollLeft;
                const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
                if (direction === '+') {
                    targetScrollLeft = Math.min(scrollContainer.scrollLeft + tileWidth, maxScrollLeft);
                } else {
                    targetScrollLeft = Math.max(scrollContainer.scrollLeft - tileWidth, 0);
                }

                this.smoothHorizontalScroll(scrollContainer, targetScrollLeft)
                    .catch((error) => {
                        window.c24Lp.logError('smoothHorizontalScroll on navPrev/navNext click failed', {
                            url: window.c24LpRoot,
                            error: error.message,
                            deviceOutput: window.c24LpDeviceOutput,
                        });
                    })
                    .finally(() => {
                        updateNavigationAndSliderConfig(targetScrollLeft);
                    });
            };
            const scrollToIndex = (index) => {
                if (this.sliderConfig.sliding) {
                    return;
                }
                this.sliderConfig.sliding = true;
                if (tileWidth === undefined || tileWidth === 0) {
                    recalculateItemWidth();
                }
                const maxIndex = Math.ceil(totalTilesCount / visibleTilesCount) - 1;
                const safeIndex = Math.max(0, Math.min(index, maxIndex));
                const targetScrollLeft = safeIndex * tileWidth * visibleTilesCount;

                this.smoothHorizontalScroll(scrollContainer, targetScrollLeft)
                    .catch((error) => {
                        window.c24Lp.logError('smoothHorizontalScroll on scrollToIndex failed', {
                            url: window.c24LpRoot,
                            error: error.message,
                            deviceOutput: window.c24LpDeviceOutput,
                        });
                    })
                    .finally(() => {
                        updateNavigationAndSliderConfig(targetScrollLeft);
                    });
            };
            const onResize = () => {
                recalculateItemWidth();
                this.rerenderLoginTileInSlider();
                updateNavigationAndSliderConfig(scrollContainer.scrollLeft);
            };
            const debounce = (func, wait) => {
                let timeout;
                return (...args) => {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(this, args), wait);
                };
            };
            const updateNavigationDots = () => {
                navDotsContainer.innerHTML = '';
                if (totalTilesCount <= visibleTilesCount || !this.tilesContainerWrapper.classList.contains('withStaticSlider')) {
                    if (!navDotsContainer.classList.contains('c24Hidden')) {
                        navDotsContainer.classList.add('c24Hidden');
                    }
                    return;

                } else {
                    navDotsContainer.classList.remove('c24Hidden');
                }
                const totalDots = Math.ceil(totalTilesCount / visibleTilesCount);

                for (let i = 0; i < totalDots; i++) {
                    const dot = document.createElement('button');
                    dot.classList.add('c24SliderNavDot');
                    const startTileIndex = totalTilesCount - visibleTilesCount * i > visibleTilesCount ? i * visibleTilesCount + 1 : totalTilesCount - visibleTilesCount + 1;
                    const endTileIndex = startTileIndex + visibleTilesCount - 1;
                    dot.ariaLabel = `Zeigen Kacheln von ${startTileIndex} bis ${endTileIndex} an`;
                    if (i === 0) dot.classList.add('active');
                    dot.dataset.index = i;
                    dot.addEventListener('click', () => scrollToIndex(i));
                    navDotsContainer.appendChild(dot);
                }
            };

            const updateActiveNavDot = (currentScrollLeft, currentTilesCount) => {
                const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
                const totalDots = Math.ceil(currentTilesCount / visibleTilesCount);
                let currentIndex = Math.round((currentScrollLeft + this.sliderConfig.scrollTolerance) / (tileWidth * visibleTilesCount));
                if (currentScrollLeft >= maxScrollLeft - this.sliderConfig.scrollTolerance) {
                    currentIndex = totalDots - 1;
                }
                navDotsContainer.querySelectorAll('.c24SliderNavDot').forEach((dot, index) => {
                    dot.classList.toggle('active', index === currentIndex);
                });
            };
            recalculateItemWidth();
            resizeListener = debounce(onResize, this.sliderConfig.scrollDebounceMs);
            scrollListener = () => this.checkSliderArrowsVisibility();
            navPrevListener = () => scrollElement('-');
            navNextListener = () => scrollElement('+');

            navPrev.addEventListener('click', navPrevListener);
            navNext.addEventListener('click', navNextListener);
            scrollContainer.addEventListener('scroll', scrollListener);
            window.addEventListener('resize', resizeListener);

            if (!navPrev.classList.contains('c24Hidden')) {
                navPrev.classList.add('c24Hidden');
            }

            const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;
            if (isScrollable) {
                navNext.classList.remove('c24Hidden');
            } else {
                navNext.classList.add('c24Hidden');
            }

            return () => {
                navPrev.removeEventListener('click', navPrevListener);
                navNext.removeEventListener('click', navNextListener);
                scrollContainer.removeEventListener('scroll', scrollListener);
                window.removeEventListener('resize', resizeListener);
            };
        }
        smoothHorizontalScroll(container, targetPosition) {
            targetPosition = Math.round(targetPosition);
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            if (targetPosition >= maxScrollLeft) {
                targetPosition = maxScrollLeft;
            }
            container.scrollTo({
                left: targetPosition,
                behavior: 'smooth',
            });
            return new Promise((resolve, reject) => {
                const failedTimeout = setTimeout(() => {
                    container.removeEventListener('scroll', scrollHandler);
                    reject(new Error('time out for smooth scroll is up'));
                }, 5000);

                const scrollHandler = () => {
                    if (Math.abs(container.scrollLeft - targetPosition) <= this.sliderConfig.scrollTolerance) {
                        container.removeEventListener('scroll', scrollHandler);
                        clearTimeout(failedTimeout);
                        resolve();
                    }
                };

                if (Math.abs(container.scrollLeft - targetPosition) <= this.sliderConfig.scrollTolerance) {
                    clearTimeout(failedTimeout);
                    resolve();
                } else {
                    container.addEventListener('scroll', scrollHandler);
                }
            });
        }
        checkSliderArrowsVisibility() {
            const scrollContainer = this.tilesContainer;
            if (scrollContainer.childElementCount === 0) {
                return;
            }
            const navPrev = document.querySelector('.c24StaticSliderNav.navPrev');
            const navNext = document.querySelector('.c24StaticSliderNav.navNext');
            const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

            if (scrollContainer.scrollLeft <= this.sliderConfig.scrollTolerance) {
                navPrev.classList.add('c24Hidden');
            } else {
                navPrev.classList.remove('c24Hidden');
            }

            if (scrollContainer.scrollLeft >= maxScrollLeft - this.sliderConfig.scrollTolerance) {
                navNext.classList.add('c24Hidden');
            } else {
                navNext.classList.remove('c24Hidden');
            }
        }
        isEmptyObject(obj) {
            if (obj === null || typeof obj !== 'object') {
                return true;
            }

            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    return false;
                }
            }

            return true;
        }
        handlePreviewTile(previewTile, apiUrl) {
            const managerTileTemplate = this.templates.managerTileTemplate;
            const previewTileElement = this.cloneAndAppendTemplate(managerTileTemplate, 0);
            const urlParams = new URLSearchParams(window.location.search);
            const hash = urlParams.get('tile_preview_hash');
            const fullApiUrl = apiUrl + '/get-preview/tile/asset/desktop/' + hash;
            this.renderManagerTile(previewTile, previewTileElement, 0, fullApiUrl);

            previewTileElement.setAttribute('data-position', 1);
            previewTileElement.classList.add('c24-preview-tile');

            this.updateDataSetPosition(1);
        }
    }

    window.c24DomReady(function() {
        if (document.querySelector('.c24-loading-tile')) {
            new TeaserTiles();
        }
    });
})();
